import moment from 'moment'

export const department = {
  id: '',
  name: '',
  updatedAt : moment().format('YYYY-MM-DD'),
}